import {
  IButtonStyles,
  ICheckboxStyles,
  IIconStyles,
  IStackStyles,
  Theme,
} from "@fluentui/react";

export const checkboxStyles = (theme: Theme): ICheckboxStyles => {
  return {
    label: {
      color: theme.palette.neutralPrimary,
    },
    checkbox: {
      borderColor: 'black'
    },
    text: {
      color: theme.palette.black
    }
  };
};

export const callingWidgetContainerStyles = (theme: Theme): IStackStyles => {
  return {
    root: {
      width: "5rem",
      height: "5rem",
      padding: "0.5rem",
      boxShadow: theme.effects.elevation16,
      borderRadius: "50%",
      bottom: "1rem",
      right: "1rem",
      position: "absolute",
      overflow: "hidden",
      cursor: "pointer",
      ":hover": {
        boxShadow: theme.effects.elevation64,
      },
      "@media (max-width: 768px)": {
        width: "4rem",
        height: "4rem",
        padding: "0.4rem",
        bottom: "0.5rem",
        right: "0.5rem",
      },
    },
  };
};

export const callingWidgetSetupContainerStyles = (
  theme: Theme
): IStackStyles => {
  return {
    root: {
      maxWidth: "500px",
      width: "fit-content",
      height: "fit-content",
      padding: "1.5rem",
      boxShadow: theme.effects.elevation64,
      borderRadius: theme.effects.roundedCorner6,
      bottom: 0,
      top:"50%",
      right:0,
      left:"50%",
      transform: "translate(-50%, -50%)",
      position: "relative",
      overflow: "hidden",
      cursor: "pointer",
      background: "#fafaf7",
      "@media (max-width: 768px)": {
        padding: "1rem",
        maxWidth: "90vw",
      },
    },
  };
};

export const callIconStyles = (theme: Theme): IIconStyles => {
  return {
    root: {
      paddingTop: "0.2rem",
      color: theme.palette.white,
      transform: "scale(1.6)",
      "@media (max-width: 768px)": {
        transform: "scale(1.4)",
      },
    },
  };
};

export const startCallButtonStyles = (theme: Theme): IButtonStyles => {
  return {
    root: {
      background: theme.palette.themePrimary,
      borderRadius: theme.effects.roundedCorner6,
      borderColor: theme.palette.themePrimary,
      "@media (max-width: 768px)": {
        padding: "0.8rem 1.6rem",
      },
    },
    textContainer: {
      color: theme.palette.white,
    },
  };
};

export const logoContainerStyles: IStackStyles = {
  root: {
    margin: "auto",
    padding: "0.2rem",
    height: "5rem", 
    width: "10rem",
    zIndex: 0,
    "@media (max-width: 768px)": {
      height: "4rem",
      width: "8rem",
    },
  },
};


export const collapseButtonStyles: IButtonStyles = {
  root: {
    position: "absolute",
    top: "0.2rem",
    right: "0.2rem",
    zIndex: 1,
    "@media (max-width: 768px)": {
      top: "0.1rem",
      right: "0.1rem",
    },
  },
};

// export const callingWidgetInCallContainerStyles = (
//   theme: Theme
// ): IStackStyles => {
//   return {
//     root: {
//       width: "35rem",
//       height: "25rem",
//       padding: "0.5rem",
//       boxShadow: theme.effects.elevation16,
//       borderRadius: theme.effects.roundedCorner6,
//       bottom: 0,
//       right: "1rem",
//       position: "absolute",
//       overflow: "hidden",
//       cursor: "pointer",
//       background: theme.semanticColors.bodyBackground,
//     },
//   };
// };

export const callingWidgetInCallContainerStyles = (
  theme: Theme
): IStackStyles => {
  return {
    root: {
      width: "100vw",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
      padding: "0.5rem",
      boxShadow: theme.effects.elevation16,
      borderRadius: theme.effects.roundedCorner6,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "absolute",
      overflow: "hidden",
      cursor: "pointer",
      background: theme.semanticColors.bodyBackground,
      "@media (max-width: 768px)": {
        width: "100vw",
        height: "100vh",
        padding: "0.25rem",
        boxShadow: theme.effects.elevation4,
        borderRadius: theme.effects.roundedCorner2,
      },
    },
  };
};
